var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.33 199.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#5876b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 199.33,
    height: 199.34,
    rx: 21.8,
    ry: 21.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.56,87.89v55.03l4.54-4.54H32.31l4.54,4.54V52.36l-4.54,4.54h132.3l-3.21-7.75c-21.22,20.23-42.44,40.47-63.66,60.7h6.42c-12.22-12.22-24.44-24.44-36.67-36.67-4.14-4.14-10.56,2.28-6.42,6.42,12.22,12.22,24.44,24.44,36.67,36.67,1.76,1.76,4.64,1.7,6.42,0,21.22-20.23,42.44-40.47,63.66-60.7,2.87-2.74.66-7.75-3.21-7.75H32.31c-2.45,0-4.54,2.08-4.54,4.54v90.56c0,2.45,2.08,4.54,4.54,4.54h133.79c2.45,0,4.54-2.08,4.54-4.54v-55.03c0-5.84-9.08-5.85-9.08,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2a96415aed2db9b56f7cf1861c65b9ff.svg";
export { ForwardRef as ReactComponent };